var isArray = Array.isArray;
export default isArray;
